import { render } from "./RewardPopin.vue?vue&type=template&id=f129a4b6&scoped=true&ts=true"
import script from "./RewardPopin.vue?vue&type=script&lang=ts"
export * from "./RewardPopin.vue?vue&type=script&lang=ts"

import "./RewardPopin.vue?vue&type=style&index=0&id=f129a4b6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f129a4b6"]])

export default __exports__